import styled from 'styled-components';

export const UnassignModalOuter = styled.div(
  () => `
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  top: 0px;
  background-color: rgba(0; 0; 0; 0.5);
  left: 0px;
  align-items: center
`
);

export const UnassignModalInner = styled.div((props) => {
  const { palette } = props.theme;
  return `
      padding: 10px;
      width: 320px;
      height: 200px;
      background-color: white;
      border-radius: 4px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;

      & div[class*="ButtonWrapper"] {
        height: 30px;
        &:first-of-type {
          margin-right: 20px;
          color: white;
          padding: 15px;
          background-color: ${palette.secondary.main}
        }
      }
  `;
});



// WEBPACK FOOTER //
// ./components/unassign-all-modal/unassign-all-modal.styled.js